import {
  getFirestore,
  collection,
  query,
  where,
  orderBy,
  getDocs,
} from 'firebase/firestore';
import moment from 'moment-timezone';
import { aggregateOverview } from './analytics/aggregate';

// Reads recent orders from Firestore (instead of the MongoDB-backed
// `order-getOverviewData` cloud function) and builds the daily online /
// in-person series client-side. Reuses the deployed (storeId, createdAt) index.
//
// Window is the last 7 days — the overview chart only ever shows 7 daily
// points. (The old function scanned 6 months but returned the 7 *oldest* days,
// which showed stale data; this is both cheaper and what the chart intends.)
const getOverviewData = async (storeId: string, cb: any) => {
  const start: number = moment().subtract(7, 'day').startOf('day').valueOf();

  try {
    const db = getFirestore();
    const snapshot = await getDocs(
      query(
        collection(db, 'orders'),
        where('storeId', '==', storeId),
        where('createdAt', '>=', start),
        orderBy('createdAt', 'desc'),
      ),
    );

    const orders = snapshot.docs.map((doc) => doc.data() as any);
    cb(aggregateOverview(orders));
  } catch (e) {
    console.error('Failed to load overview data', e);
    cb({ onlineData: [], inPersonData: [] });
  }
};

export default getOverviewData;
